import React, {
    useState
} from 'react';

import {
    useDispatch,
    useSelector
} from 'react-redux';

import {
    Link
} from 'react-router-dom';


// Actions
import {
    restablecerPasswordAction
} from '../../actions/restablecerPasswordActions';

import {
    setearAlerta,
    ocultarAlertaAction
} from '../../actions/alertaActions';


// CSS
import {
    PaginaAuth,
    HeaderAuth,
    LogoLink,
    Logo,
    HeaderAcciones,
    LinkHeader,

    ContenidoAuth,
    PanelIlustracion,
    ImagenAuth,

    TarjetaAuth,
    EncabezadoAuth,
    TituloAuth,
    TextoAuth,

    EtiquetaGrupo,
    TipoGrid,
    TipoButton,

    FormularioAuth,
    CampoAuth,
    LabelAuth,
    InputAuth,

    BotonPrincipalAuth,

    LinksAuth,
    LinkAuth,

    MensajeAuth
} from '../Css/StyledAuth';


const RestablecerPassword = () => {

    const dispatch =
        useDispatch();


    /*
    ========================================
    FORM
    ========================================
    */

    const [
        email,
        guardarEmail
    ] =
        useState('');


    const [
        tipoUsuario,
        setTipoUsuario
    ] =
        useState(
            'Profesional'
        );


    /*
    ========================================
    REDUX
    ========================================
    */

    const cargando =
        useSelector(
            state =>
                state.estado.loading
        );


    const error =
        useSelector(
            state =>
                state.estado.error
        );


    const alerta =
        useSelector(
            state =>
                state.alertas.alerta
        );


    /*
    ========================================
    TIPO USUARIO
    ========================================
    */

    const cambiarTipoUsuario = (
        tipo
    ) => {

        dispatch(
            ocultarAlertaAction()
        );


        setTipoUsuario(
            tipo
        );

    };


    /*
    ========================================
    SUBMIT
    ========================================
    */

    const submitRestablecerPassword = (
        e
    ) => {

        e.preventDefault();


        const emailLimpio =
            email
                .trim()
                .toLowerCase();


        if (
            !emailLimpio
        ) {

            dispatch(
                setearAlerta({
                    msg:
                        'Falta completar el email'
                })
            );


            return;

        }


        const emailValido =
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/
                .test(
                    emailLimpio
                );


        if (
            !emailValido
        ) {

            dispatch(
                setearAlerta({
                    msg:
                        'Ingresá un email válido'
                })
            );


            return;

        }


        dispatch(
            ocultarAlertaAction()
        );


        dispatch(
            restablecerPasswordAction({

                payload: {

                    email:
                        emailLimpio,

                    tipoUsuario

                }

            })
        );

    };


    /*
    ========================================
    MENSAJES
    ========================================
    */

    const mensajeError =

        typeof error ===
        'string'

            ?
            error

            :
            error?.msg ||
            '';


    const nombreTipo =

        tipoUsuario ===
        'Paciente'

            ?
            'Entrenado'

            :
            tipoUsuario;


    return (

        <PaginaAuth>


            <HeaderAuth>


                <LogoLink
                    as={Link}
                    to="/"
                >

                    <Logo
                        src="/img/metodoYogenLogo_recortado.png"
                        alt="Método YÖGEN"
                    />

                </LogoLink>


                <HeaderAcciones>


                    <LinkHeader
                        as={Link}
                        to="/nueva-cuenta"
                    >

                        Nueva cuenta profesional

                    </LinkHeader>


                    <LinkHeader
                        as={Link}
                        to="/login"
                    >

                        Iniciar sesión

                    </LinkHeader>


                </HeaderAcciones>


            </HeaderAuth>


            <ContenidoAuth>


                <PanelIlustracion>


                    <ImagenAuth

                        src="/img/ilustracionRestablecerPassword.png"

                        alt=""

                    />


                </PanelIlustracion>


                <TarjetaAuth>


                    <EncabezadoAuth>


                        <TituloAuth>

                            ¿Olvidaste tu contraseña?

                        </TituloAuth>


                        <TextoAuth>

                            Seleccioná el tipo de cuenta
                            e ingresá el email de tu {
                                nombreTipo
                            }.

                            Te enviaremos un código para
                            crear una nueva contraseña.

                        </TextoAuth>


                    </EncabezadoAuth>


                    <EtiquetaGrupo>
                        Tipo de cuenta
                    </EtiquetaGrupo>


                    <TipoGrid>


                        <TipoButton

                            type="button"

                            $activo={
                                tipoUsuario ===
                                'Profesional'
                            }

                            onClick={() =>
                                cambiarTipoUsuario(
                                    'Profesional'
                                )
                            }

                        >

                            Profesional

                        </TipoButton>


                        <TipoButton

                            type="button"

                            $activo={
                                tipoUsuario ===
                                'Paciente'
                            }

                            onClick={() =>
                                cambiarTipoUsuario(
                                    'Paciente'
                                )
                            }

                        >

                            Entrenado

                        </TipoButton>


                        <TipoButton

                            type="button"

                            $activo={
                                tipoUsuario ===
                                'Screening'
                            }

                            onClick={() =>
                                cambiarTipoUsuario(
                                    'Screening'
                                )
                            }

                        >

                            Screening

                        </TipoButton>


                    </TipoGrid>


                    <FormularioAuth

                        onSubmit={
                            submitRestablecerPassword
                        }

                        noValidate

                    >


                        <CampoAuth>


                            <LabelAuth
                                htmlFor="email"
                            >

                                Email

                            </LabelAuth>


                            <InputAuth

                                type="email"

                                id="email"

                                name="email"

                                autoComplete="email"

                                placeholder="nombre@email.com"

                                value={
                                    email
                                }

                                disabled={
                                    cargando
                                }

                                onChange={
                                    e => {

                                        guardarEmail(
                                            e.target.value
                                        );


                                        if (
                                            alerta
                                        ) {

                                            dispatch(
                                                ocultarAlertaAction()
                                            );

                                        }

                                    }
                                }

                            />


                        </CampoAuth>


                        <BotonPrincipalAuth

                            type="submit"

                            disabled={
                                cargando
                            }

                        >

                            {
                                cargando
                                    ?
                                    'Enviando código...'
                                    :
                                    'Enviar código'
                            }

                        </BotonPrincipalAuth>


                    </FormularioAuth>


                    <LinksAuth>


                        <LinkAuth
                            as={Link}
                            to="/login"
                        >

                            Volver a iniciar sesión

                        </LinkAuth>


                    </LinksAuth>


                    {
                        mensajeError && (

                            <MensajeAuth $error>

                                {
                                    mensajeError
                                }

                            </MensajeAuth>

                        )
                    }


                    {
                        alerta?.msg && (

                            <MensajeAuth $error>

                                {
                                    alerta.msg
                                }

                            </MensajeAuth>

                        )
                    }


                </TarjetaAuth>


            </ContenidoAuth>


        </PaginaAuth>

    );

};


export default RestablecerPassword;